import {Component, effect, ElementRef, input, SecurityContext, viewChild, ViewChild} from '@angular/core';
import * as marked from 'marked';
import {DynamicComponentBase} from '../../service/ng-dynamic-components.service';
import DOMPurify from 'dompurify';

@Component({
    selector: 'app-markdown-renderer',
    standalone: true,
    templateUrl: './markdown-renderer.component.html',
    styleUrls: ['./markdown-renderer.component.scss']
})
export class MarkdownRendererComponent extends DynamicComponentBase {

    markdown = input<string | null | undefined>(null);
    targetEl = viewChild<ElementRef<HTMLElement>>('target');

    // Using a static instance of marked renderer that is shared across the application
    static markedRenderer: marked.Marked = new marked.Marked({
        async: false,
        pedantic: false,
        gfm: true
    });

    constructor() {
        super();
        effect(async () => this.render(this.markdown()));
    }

    render(markdownCode: string | null | undefined): void {
        const renderEl = this.targetEl()?.nativeElement;
        if (renderEl) {
            if (markdownCode == null) {
                renderEl.innerHTML = '';
            } else {
                renderEl.innerHTML = MarkdownRendererComponent.syncParseAndPurify(markdownCode);
            }
        }
    }

    static syncParseAndPurify(markdownCode: string): string {
        const html = MarkdownRendererComponent.markedRenderer.parse(markdownCode, { async: false });
        const purified = DOMPurify.sanitize(html, {
            FORBID_ATTR: ['href', 'src', 'style'],
            FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed'],
            // ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'ul', 'ol', 'li', 'br', 'span', 'div'],
            // ALLOWED_ATTR: ['class', 'id', 'title'],
        });
        return purified;
    }
}
